<template>
    <div class="row filters">
        <div class="col-md-12">
            <base-input>
                <el-select v-model="selectedTypes"
                        multiple
                        class="select-info"
                        :placeholder="$t('logs.select-types')"
                        @change="changed">

                    <el-option v-for="(type, id) in filteringTypes"
                            :key="id"
                            :label="types[id].name[lang]"
                            :value="id"
                            class="select-primary"
                    >
                        <i :class="type.icon + ' text-' + type.color + ' mr-2'"></i>{{ types[id].name[lang] }}
                    </el-option>

                </el-select>
            </base-input>
            <div class="row pt-3">
                <div class="col-md-6">
                    <base-checkbox class="mb-3 d-inline-block mr-3" v-model="position1">
                        {{ registration.degree.simulation_role_1_name[lang] }}
                    </base-checkbox>

                    <base-checkbox class="mb-3 d-inline-block mr-3" v-model="position2" v-if="registration.degree.simulation_role_2_name">
                        {{ registration.degree.simulation_role_2_name[lang] }}
                    </base-checkbox>

                    <base-checkbox class="mb-3 d-inline-block" v-model="showCompetencies">
                        {{ $t('logs.show-competencies') }}
                    </base-checkbox>
                </div>
                <div class="col-md-6 text-right">
                    <base-button type="white mr-1" size="sm" @click="selectAllTypes">
                        {{ $t('common.select-all') }}
                    </base-button>
                    
                    <base-button type="white" size="sm" @click="unselectAllTypes">
                        {{ $t('common.unselect-all') }}
                    </base-button>
                </div>
            </div>
            <div class="text-center pt-2" v-if="hasChanged">
                <base-button type="primary" @click="apply">
                    {{ $t('common.apply') }}
                </base-button>
                <base-button type="link" @click="cancel">
                    {{ $t('common.cancel') }}
                </base-button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {

        props: {

            value: {
                type: Object,
                default: {}
            },

            registration: {
                type: Object,
                required: true
            },

            types: {
                type: Object,
                required: true
            },

            lang: {
                type: String,
                default: "en"
            },

            restore: {
                type: Boolean,
                default: false
            },
        },

        data() {
            return {
                selectedTypes: [],
                position1: true,
                position2: true,
                showCompetencies: false,
                hasChanged: false,
                savedFilters: this.$auth.getUiConfig('log_filters')
            }
        },

        created() {
            if (this.restore && this.savedFilters) {
                this.$emit('input', this.savedFilters)
            }
        },

        mounted() {
            this.cancel()
        },

        watch: {

            position1(newVal) {
                this.changed()
            },

            position2(newVal) {
                this.changed()
            },

            showCompetencies(newVal) {
                this.changed()
            },

            value(newVal) {
                this.cancel()
            }
        },

        computed: {

            filteringTypes() {
                const types = {...this.types}
                delete types.position_change
                return types
            },
        },

        methods: {

            selectAllTypes() {
                this.selectedTypes = Object.keys(this.filteringTypes);
                this.changed()
            },

            unselectAllTypes() {
                this.selectedTypes = []
                this.changed()
            },

            changed() {
                this.hasChanged = true
            },

            apply() {
                this.$loader.show()
                setTimeout(this.applyNow, 300)
            },

            applyNow() {
                this.$emit('input', this.filters())
                this.$nextTick(() => {
                    this.hasChanged = false
                    this.$loader.hide()
                    this.rememberFilters()
                })
            },

            cancel() {
                this.selectedTypes = this.value.selectedTypes
                this.position1 = this.value.position1
                this.position2 = this.value.position2
                this.showCompetencies = this.value.showCompetencies
                this.$nextTick(() => {
                    this.hasChanged = false
                })
            },

            rememberFilters() {
                this.$auth.setUiConfig(this.filters(), 'log_filters')
            },

            filters() {
                return {
                    selectedTypes: this.selectedTypes,
                    position1: this.position1,
                    position2: this.position2,
                    showCompetencies: this.showCompetencies,
                }
            },
        }
    }
</script>

<style scoped>
    .filters >>> .form-group {
        margin-bottom: 0;
    }
    .filters >>> .el-select.select-info .el-select__tags .el-tag {
        background: #5e72e4;
    }
</style>
